import { render, staticRenderFns } from "./NavFiltersDesktop.vue?vue&type=template&id=52819adf&"
import script from "./NavFiltersDesktop.vue?vue&type=script&lang=js&"
export * from "./NavFiltersDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports